export default __webpack_public_path__ + "/dist/images/recipe-img1.png";